/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2024, Zumper
 * @description   DetailNavbarBackBtn for redesign
 */

import { selectIsOnlyActiveUnitOfMultiUnit, selectIsSingleUnit } from '@zcode-ui/perm-address'
import { selectIsAddressOnBuilding } from '@zcode-ui/web-zumper-global-state'
import { AddressBackNavButton, DetailBackNavButton } from '@zcode-ui/web-zumper-pages'
import React from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

interface DetailNavbarBackBtnProps {
  isDetailView?: boolean
}

const backBtnStyle = {
  background: 'transparent',
  height: 5,
  sx: {
    '> svg > path': {
      stroke: '#0A0F1C',
    },
  },
  width: 5,
}

export const DetailNavbarBackBtn = ({ isDetailView }: DetailNavbarBackBtnProps) => {
  const isSingleUnit = useSelector(selectIsSingleUnit)
  const isOnlyActiveUnitOfMultiUnit = useSelector(selectIsOnlyActiveUnitOfMultiUnit)
  const isAddressOnBuilding = useSelector(selectIsAddressOnBuilding)
  const location = useLocation()
  const isUnitOfMultiUnit = location.search.includes('listing_id')

  if (
    !isUnitOfMultiUnit &&
    !isSingleUnit &&
    !isOnlyActiveUnitOfMultiUnit &&
    (!isDetailView || isAddressOnBuilding)
  ) {
    return <AddressBackNavButton {...backBtnStyle} />
  }
  return <DetailBackNavButton className="bg-transparent size-5 [&>svg>path]:stroke-gray-950" />
}
